import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import IconButton from '@mui/material/IconButton'
import classNames from 'classnames'
import { tokens } from '../../styles/tokens'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    transition: `background-color ${tokens.transition.fast}, box-shadow ${tokens.transition.fast}`,
    '&:hover': {
      backgroundColor: tokens.color.primary[800],
      boxShadow: tokens.shadow.sm,
    },
    '&.Mui-disabled': {
      backgroundColor: tokens.color.neutral[200],
      color: tokens.color.neutral[400],
    },
  },
}))

interface Props {
  onClick?: () => void
  icon?: React.ReactNode
  size?: 'small' | 'medium' | undefined
  className?: string
  disabled?: boolean
  title?: string
}

export const ColoredIconButton: React.FC<Props> = ({ onClick, icon, size, className, disabled, title }) => {
  const classes = useStyles()

  return (
    <IconButton
      className={classNames(classes.root, className)}
      onClick={onClick}
      disabled={disabled ? disabled : false}
      size={size}
      title={title}
    >
      {icon}
    </IconButton>
  )
}
